import { ABREVIATION_TO_SYMBOL_MAP } from "@/constants/sales.js";

export default {
  data() {
    return {
      changeStatusVisible: false,
      status: false,
      loading: false,
      productActions: [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Duplicar produto",
          class: "",
          icon: "fa-regular fa-copy",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "duplicate"
        },
        {
          text: "Links de divulgação",
          class: "fw-400",
          icon: "fa fa-link",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "links"
        },
        {
          text: "Desativar produto",
          class: "text-danger font-weight-normal",
          icon: "fa fa-power-off",
          confirmation: {
            enable: true,
            text:
              "Tem certeza que deseja desativar este produto? Ao confirmar este produto não estará mais disponível para compra até que você o reative."
          },
          event: "inactivate"
        },
        {
          text: "Ativar produto",
          class: "text-success font-weight-normal",
          icon: "icon-power",
          confirmation: {
            enable: true,
            text:
              "Ativando o produto ele ficará disponível para compra, confirmar?"
          },
          event: "activate"
        }
      ]
    };
  },
  filters: {
    formatStatus(dt) {
      const toMap = {
        active: "Ativo",
        inactive: "Inativo",
        draft: "Pendente",
        in_review: "Em revisão",
        reject: "Rejeitado"
      };
      return toMap[dt];
    },
    formatFemStatus(dt) {
      const toMap = {
        active: "Ativas",
        inactive: "Inativas",
        draft: "Conf. pendente",
        in_review: "Em revisão",
        reject: "Rejeitada"
      };
      return toMap[dt];
    },
    formatCurrency(dt) {
      return ABREVIATION_TO_SYMBOL_MAP[dt];
    },
    formatPayment(list) {
      return list.map(m => m.name).join(", ");
    }
  },
  methods: {
    openLinks(item) {
      this.$router.push({
        name: "product-links",
        params: { id: item.id }
      });
    },
    preparedActions(item) {
      let actions = this.productActions;

      if (item.status === "inactive") {
        return actions.filter(a => !a.text.match("Desativar"));
      }

      if (item.status === "active") {
        return actions.filter(a => !a.text.match("Ativar"));
      }

      return actions.filter(
        a => !a.text.match("Ativar") && !a.text.match("Desativar")
      );
    },
    statusClass(status) {
      const cmap = {
        active: "active-wrapper",
        draft: "draft-wrapper",
        inactive: "inactive-wrapper"
      };
      return cmap[status];
    },
    duplicate(product) {
      this.$store.dispatch("product/duplicate", product.id).then(() => {
        this.$store.dispatch("product/get");
        this.$message.success("Produto duplicado!");
      });
    },
    changeStatus() {
      this.submitStatus(this.product, this.status ? "active" : "inactive");
    },
    cancelChangeStatus() {
      this.changeStatusVisible = false;
    },
    open(item) {
      this.$router.push({
        name: "product-details",
        params: { id: item.id }
      });
    },
    openLinks(item) {
      this.$router.push({
        name: "product-links",
        params: { id: item.id }
      });
    },
    submitStatus(item, status) {
      this.$store
        .dispatch("product/put", { id: item.id, status })
        .then(() => {
          this.$message.success(
            `O Produto foi ${status === "active" ? "ativado" : "desativado"}!`
          );
          if (this.$route.name === "product") {
            this.$store.dispatch("product/get", { limit: 20 }).then();
          } else {
            this.$store.dispatch("product/getProduct", item.id).then();
          }
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }

          if (this.errors.details) {
            this.$message.error(this.errors.details);
          }

          if (error.response.data.status === "notfound") {
            this.$message.error("Sessão Expirada");
          }
        })
        .finally(() => {
          this.loadingPage = false;
        });
    },
    submitDelete(item) {
      this.$store
        .dispatch("product/delete", item.id)
        .then(() => {
          this.$message.success("O Produto foi excluído!");
          if (this.$route.name === "product") {
            this.$store.dispatch("product/get", { limit: 20 }).then();
          } else {
            this.$router.push({ name: "product" });
          }
          this.$store.commit("product/setProduct", null);
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }

          if (this.errors.details) {
            this.$message.error(this.errors.details);
          }

          if (error.response.data.status === "notfound") {
            this.$message.error("Sessão Expirada");
          }
        })
        .finally(() => {
          this.loadingPage = false;
        });
    }
  }
};
